import { ApiProperty } from '@nestjs/swagger';
export class EndCustomerImgUploadDto {
    @ApiProperty({ type: 'file', format: 'binary' })
    file: string;
    @ApiProperty()
    endCustomerId: number;
}